export const getEnvironment = () => {
  // Extract the domain from the current URL
  const domain = window.location.hostname;

  // Check the domain to determine the environment
  if (domain === "localhost") {
    return "local";
  } else if (domain.includes("-dev.")) {
    return "development";
  } else if (domain.includes("-stage.")) {
    return "staging";
  } else {
    return "";
  }
};
